const keysToInts = (key: string) => parseInt(key, 10);
const toIntsOnly = (n: number) => !Number.isNaN(n);
const toSizeRange = (n: number) => n > 1 && n <= 1000;

export function resolveIntegerList(obj: Record<string, any>) {
  if (!obj) return null;
  const intList = new Set(Object.keys(obj).map(keysToInts).filter(toIntsOnly));

  return intList.size ? Array.from(intList) : null;
}

export function resolveRowOptsList({ rawVal }: { rawVal: Record<string, string> }) {
  if (!rawVal) return null;
  const optsArray = resolveIntegerList({ ...rawVal, 10: '' })?.filter(toSizeRange) || null;

  return optsArray;
}
